import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const QueueTypesAndApplications = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Queue: Different types and Applications"
    videos={[
      "https://www.youtube.com/embed/zp6pBNbUB2U",
      "https://www.youtube.com/embed/dn01XST9-bI",
      "https://www.youtube.com/embed/pqg0SOPRlJ4",
      "https://www.youtube.com/embed/jz6-VP5BxyQ"
    ]}
    takeaways={[
      { text: "Expect scenario-based questions especially from deque and circular queue." },
      { text: "Learn all the pseudo codes and practice few application-based questions." }
    ]}
    questions={[
      "a) List out the advantages of circular queue. (Any three enough)\nb) Engrave pseudocode to perform operations on circular Queue. Assume the initial state of the Circular Queue is Empty with size N=4 and demonstrate the following operations with an appropriate diagram with the status of REAR and FRONT pointers.\n 1. Successive Insertion of the elements 10, 20, 30, 40, 50.\n 2. Successive Deletion of two elements.\n 3. Insertion of the element 50.\n 4. Successive deletion of three elements.",
      "Discuss the limitation of a linear queue. Illustrate how this is overcome in circular queue with the help of a suitable example.",
      "Narrate the following operations in a circular queue of size 10. Show the status of circular queue for each of the print operation\nfor (int k= 9; k>=0; k -- )\nprintf(enqueue(k));\nfor (int k= 0; k < 4; k++)\n{printf(dequeue());\nprintf(enqueue(dequeue()));\nprintf(dequeue());}",
      "Explain the working of Queue implementation and its operations with example and provide the pseudocode for all the queue operations.",
      "Differentiate the circular queue from Queue ADT",
      "Assume that the operation ENQUEUE (CQ, x) inserts an item x into a circular queue CQ and another operation DEQUEUE (CQ) deletes an item from CQ in FIFO manner. Draw the circular queue of size 6. Illustrate the working for the following eight commands (in the given order) over that circular queue (illustrate with diagram for execution of every command), also give the values of the variables FRONT and REAR on execution of each command;\n(i) ENQUEUE (CQ, 10);\n(ii) ENQUEUE (CQ, 20);\n(iii) ENQUEUE (CQ, 30);\n(iv) DEQUEUE (CQ);\n(v) ENQUEUE (CQ, 40);\n(vi) ENQUEUE (CQ, 50);\n(vii) ENQUEUE (CQ, 60);\n(viii) DEQUEUE (CQ);"
    ]}
    exampleVideos={[]}
  />
);
}

export default QueueTypesAndApplications;
